var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"i-zyl-com-my-loader",style:({ 'background': _vm.backColor }),on:{"click":_vm.handleClick}},[_c('span',{staticClass:"i-zyl-com-my-loader-one"}),_c('div',{staticClass:"i-zyl-com-my-loader-txt"},[_vm._v(_vm._s(_vm.showTxt))])])
}
var staticRenderFns = []

export { render, staticRenderFns }